import delegate from 'delegate'
import {VideoPlayer} from './videoplayer'

/**
  * @class VideoCarousel
  *
  * Initialises videos within a flickity carousel using VideoPlayer, pausing
  * the carousel where appropriate.
  */
class VideoCarousel {
  constructor (flkty, opts = {}) {
    this.flkty = flkty
    this.opts = opts
    this.videoPlayers = Array(...this.flkty.element.querySelectorAll('.video-player'))
    this.states = {
      mousedown: false,
      playing: true,
      fullscreen: false
    }
    this.enabled = true
    this.el = this.flkty.element

    // this.videos = el.querySelectorAll('video')
    // this.playpauses = el.querySelectorAll('.playpause')

    this.players = []

    const playingHandler = (playing) => () => {
      this.states.playing = playing
      this.setCarouselState()

      // $(this).closest('.video-player').removeClass('loading-spinner-only');
    }

    // const endedHandler = () => {
    //
    // }

    Array(...this.flkty.element.querySelectorAll('.video-player'))
      .forEach(playerEl => {
        // console.log(playerEl)
        this.players.push(new VideoPlayer(playerEl, {
          handlers: {
            // ended: () => endedHandler,
            playing: () => playingHandler(true),
            pause: () => playingHandler(false)
          }
        }))
      })

    // // Pause playing video if it is clicked, but we don't do the reverse
    // // as the click may be inadvertent; the user may have been trying to
    // // swipe the carousel.
    // this.el.on('click', '.video-player.playing video', function (e) {
    //   e.preventDefault();
    //   $(this).closest('.video-player').data('video-player').pause();
    // });

    // Whenever carousel changes, pause videos inside carousel
    this.flkty.on('select', () => {
      // TODO only pause players that are playing? Need a way to determine
      // VideoPlayer state
      this.players.forEach(player => {
        player.pause()
      })
    })

    // Disable flickity drag on mousedown of the play / pause button, and
    // renable when appropriate
    const mouseHandler = (down) => () => {
      this.states.mousedown = down
      this.setCarouselState()
    }
    delegate(this.el, '.playpause', 'mousedown', mouseHandler(true))
    delegate(this.el, '.playpause', 'mouseleave', mouseHandler(false))
    delegate(this.el, '.playpause', 'mouseup', mouseHandler(false))

    // delegate(this.el, '.playpause', 'click', () => {
    //   // if this click makes the video pause then drag will be reenabled
    //   // below.
    //   $.proxy(that.disableCarousel, that)();
    //   // can take a while for the video to play on Safari, show a loading
    //   // spinner in the meantime.
    //   var wrap = $(this).closest('.video-player');
    //   if (!wrap.hasClass('playing') && !wrap.hasClass('paused')) {
    //     wrap.addClass('loading-spinner-only');
    //   }
    // })

    // this.videos.on('ended', function () {
    //   $(this).closest('.video-player')
    //          .data('video-player')
    //          .toggleFullscreen(false);
    //   $.proxy(that.enableCarousel, that)();
    // });

    // detect fullscreen videos
    document.addEventListener('fullscreenchange', () => {
      this.states.fullscreen = document.fullScreen || document.fullscreenElement
      this.setCarouselState()
    })
    document.addEventListener('webkitfullscreenchange', () => {
      this.states.fullscreen = document.webkitIsFullScreen
      this.setCarouselState()
    })
    document.addEventListener('mozfullscreenchange', () => {
      this.states.fullscreen = document.mozFullScreen
      this.setCarouselState()
    })
    document.addEventListener('msfullscreenchange', () => {
      this.states.fullscreen = document.msFullscreenElement
      this.setCarouselState()
    })
  }

  setCarouselState () {
    const enable = this.states.mousedown && !this.states.fullscreen
    if (enable && !this.enabled) {
      this.enableCarousel()
      this.enabled = true
    } else if (!enable && this.enabled) {
      this.disableCarousel()
      this.enabled = false
    }
  }

  disableCarousel () {
    this.el.classList.add('hide-navigation')
    this.flkty.unbindDrag()
    // this.flkty.element.removeEventListener('keydown', this.flkty)
  }

  enableCarousel () {
    this.el.classList.remove('hide-navigation')
    this.flkty.bindDrag()
    // this.flkty.element.addEventListener('keydown', this.flkty)
  }
}

export default VideoCarousel



// WEBPACK FOOTER //
// ./assets/j/src/VideoCarousel.js